// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"acc1789c","2":"62b20e14","15":"6ea0d2e0","163":"b0ec5f27","220":"77d4ae6c","269":"295989d7","314":"11729f89","724":"eea498d1","859":"97e44362","872":"f3ac43ef","890":"37bd728a"}[chunkId] + ".chunk.js";
};